"use strict";
exports.__esModule = true;
exports.SvgConversationsAdd = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgConversationsAdd = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 14" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "#727272", fillRule: "nonzero", d: "M6 2v.5a5 5 0 005 5h1.5v1.763c0 1.317-.41 1.712-1.678 1.743l-.17.002-3.252-.001-2.696 2.766a.75.75 0 01-1.28-.42l-.007-.103-.001-2.243h-1.39C.908 11.005.535 10.624.503 9.495L.5 9.327V3.62C.513 2.355.953 2 2.283 2H6z" }),
        react_1["default"].createElement("path", { fill: "#3576BA", d: "M10.5 0a.75.75 0 01.75.75v1.5h1.5a.75.75 0 010 1.5h-1.5v1.5a.75.75 0 01-1.5 0V3.749l-1.5.001a.75.75 0 010-1.5l1.5-.001V.75A.75.75 0 0110.5 0z" })))); };
//# sourceMappingURL=ConversationsAdd.js.map